import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-29bd8efc")

_pushScopeId("data-v-29bd8efc")
const _hoisted_1 = { class: "footer-items" }
const _hoisted_2 = { class: "footer-item" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" © ")
const _hoisted_4 = { class: "footer-item" }
const _hoisted_5 = { class: "footer-item" }
const _hoisted_6 = { class: "footer-item-lang" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_SelectLanguage = _resolveComponent("SelectLanguage")

  return (_openBlock(), _createBlock("footer", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("span", _hoisted_2, [
        _createVNode("span", null, [
          _hoisted_3,
          _createVNode("a", {
            class: "heselclinic--link",
            href: _ctx.company.url
          }, _toDisplayString(_ctx.company.name), 9, ["href"])
        ])
      ]),
      _createVNode("div", null, [
        _createVNode("span", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: { name: _ctx.RouterName.LEGAL, params: { page: 0 } },
            class: "legal--link"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("privacy")), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createVNode("span", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: { name: _ctx.RouterName.LEGAL, params: { page: 1 } },
            class: "legal--link"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("terms of use")), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_SelectLanguage)
      ])
    ])
  ]))
})